export default "__VITE_ASSET__DrR9KzMO__"